module.exports = __webpack_public_path__ + "static/media/Elephant3.d01131d3.png";